/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { getArticuloData } from "../../services/ArticuloService";
import { getTiposAjusteStock } from "../../services/TipoAjusteStockService.js";
import DatosAccesorio from "../consulta-articulo/DatosAccesorio.jsx";
import DatosArmazon from "../consulta-articulo/DatosArmazon.jsx";
import DatosAnteojoSol from "../consulta-articulo/DatosAnteojoSol.jsx";
import DatosFornitura from "../consulta-articulo/DatosFornitura.jsx";
import DatosLenteContacto from "../consulta-articulo/DatosLenteContacto.jsx";
import DatosSolucionLimpieza from "../consulta-articulo/DatosSolucionLimpieza.jsx";
import WaitingDialog from "../../utils/WaitingDialog";
import { limpiaCodigo } from "../../utils/utils.js";

const initialAjusteArticuloItem = {
  id: "",
  id_articulo: "",
  codigoArticulo: "",
  idTipoAjuste: "",
  cantidad: 0,
  descripcionAjusteArticulo: "",
};

let actionCrudDescription = "";
//
// ########################################################################### 
//
const AjusteArticuloDialog = ({
  actionCrud,
  ajusteArticuloItem,
  onSave,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [ajusteArticuloItemLocal, setAjusteArticuloItemLocal] = useState(initialAjusteArticuloItem);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [tipoArticulo, setTipoArticulo] = useState("");
  const [articuloData, setArticuloData] = useState({});
  const [codigoArticuloDisabled, setCodigoArticuloDisabled] = useState(false);

  const [tiposAjusteStock, setTiposAjusteStock] = useState([]);
  const [valueACTiposAjusteStock, setValueACTiposAjusteStock] = useState(null);
  const [inputValueACTiposAjusteStock, setInputValueACTiposAjusteStock] = useState("");
  //
  // ################################################################################ 
  //
  useEffect(() => {
    if (actionCrud === "new") {
      actionCrudDescription = "Agregar"
    } else if (actionCrud === "update") {
      actionCrudDescription = "Editar"
    } else if (actionCrud === "view") {
      actionCrudDescription = "Ver"
    } else if (actionCrud === "delete") {
      actionCrudDescription = "Eliminar"
    }

    loadTiposAjusteStock();

    if (actionCrud !== "new") {
      loadArticulo(ajusteArticuloItem.codigo_articulo);
      setValueACTiposAjusteStock({
        id: ajusteArticuloItem.id_tipo_ajuste_stock,
        label: ajusteArticuloItem.descripcion_tipo_ajuste_stock,
        suma_resta: ajusteArticuloItem.suma_resta,
      });
    }

    setAjusteArticuloItemLocal({
      ...ajusteArticuloItemLocal,
      id: ajusteArticuloItem.id ?? "",
      id_articulo: ajusteArticuloItem.id_articulo ?? "",
      codigoArticulo: ajusteArticuloItem.codigo_articulo ?? "",
      cantidad: Number(ajusteArticuloItem.cantidad ?? 0),
      tipoArticulo: ajusteArticuloItem?.tipoArticulo ?? ajusteArticuloItem?.tipo_articulo ?? "",
      descripcionAjusteArticulo: ajusteArticuloItem?.descripcionAjusteArticulo ?? ajusteArticuloItem?.descripcion_ajuste_articulo ?? "",
    });
  }, []);
  //
  // ################################################################################
  //
  const loadTiposAjusteStock = async () => {

    setIsDoingSomething(true);
    const response = await getTiposAjusteStock();
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      let _tiposAjuste = [];
      _response.forEach((item) => {
        _tiposAjuste.push({
          id: item.id,
          label: item.descripcion,
          suma_resta: item.suma_resta,
        });
      });
      setTiposAjusteStock(_tiposAjuste);
    } else {
      setTiposAjusteStock([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let finalValue = type === "checkbox" ? e.target.checked : value;
    if (name === "cantidad") {
      const filtered = String(value).replace(/\D/g, "");
      finalValue = filtered === "" ? 0 : parseInt(filtered, 10);
    }
    setAjusteArticuloItemLocal({
      ...ajusteArticuloItemLocal,
      [name]: finalValue,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {

    if (actionCrud === "new" || actionCrud === "update") {

      if (!ajusteArticuloItemLocal.codigoArticulo) {
        setMessage({
          severity: "error",
          messageText: "El código de artículo no es válido",
        });
        setShowMessage(true);
        return;
      }

      if (!valueACTiposAjusteStock) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el tipo de ajuste",
        });
        setShowMessage(true);
        return;
      }

      if (ajusteArticuloItemLocal.cantidad < 1 || isNaN(ajusteArticuloItemLocal.cantidad)) {
        setMessage({
          severity: "error",
          messageText: "La cantidad ingresada no es válida",
        });
        setShowMessage(true);
        return;
      }
    }

    const _ajusteArticuloItem = {
      id: actionCrud === "new" ? uuidv4() : ajusteArticuloItemLocal.id,
      id_articulo: articuloData.id,
      codigo_articulo: articuloData.codigo,
      descripcion_articulo: articuloData.descripcion_compuesta,
      cantidad: ajusteArticuloItemLocal.cantidad,
      descripcion_ajuste_articulo: ajusteArticuloItemLocal.descripcionAjusteArticulo,
      descripcion_tipo_ajuste_stock: valueACTiposAjusteStock.label,
      id_tipo_ajuste_stock: valueACTiposAjusteStock.id,
      suma_resta: valueACTiposAjusteStock.suma_resta,
    };

    onSave(_ajusteArticuloItem, actionCrud);

    if (actionCrud === "new") {
      cleanArticulo();
    } else {
      onClose();
    }
  };
  //
  // ################################################################################ 
  //
  const loadArticulo = async (parCodigoArticulo) => {

    const _codigoArticulo = limpiaCodigo(parCodigoArticulo);

    if (!_codigoArticulo) {
      return;
    }

    if (_codigoArticulo.length > 20) {
      setMessage({
        messageText: "El código de artículo no es válido",
        severity: "warning",
      });
      setShowMessage(true);
      return;
    }

    setAjusteArticuloItemLocal({
      ...ajusteArticuloItemLocal,
      codigoArticulo: _codigoArticulo,
    });

    loadArticuloData(_codigoArticulo);
  };
  //
  // ################################################################################
  //
  const loadArticuloData = async (parCodigoArticulo) => {

    let _params = {
      codigo: parCodigoArticulo,
    };

    setIsDoingSomething(true);
    const response = await getArticuloData(_params);
    setIsDoingSomething(false);

    if (response.ok) {

      const _tipoArticulo = response.data.data ? response.data.data[0].tipo_articulo : "";

      if ([
        "servicio",
        "tratamiento"
      ].includes(_tipoArticulo)) {
        setMessage({
          severity: "error",
          messageText: "El código ingresado es de un tipo de artículo no permitido en un Ajuste de Artículos",
        });
        setShowMessage(true);
        return;
      };

      setArticuloData(response.data.data[0]);
      setTipoArticulo(response.data.data[0].tipo_articulo);
      setCodigoArticuloDisabled(true);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ######################################22##########################################
  //
  const cleanArticulo = () => {

    setAjusteArticuloItemLocal({
      codigoArticulo: "",
      idTipoAjuste: "",
      cantidad: 0,
      descripcionAjuste: "",
    });

    setTipoArticulo("");
    setArticuloData({});
    setCodigoArticuloDisabled(false);
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="lg"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrudDescription} Artículo
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={2} lg={2}>
              <TextField
                sx={{ width: "100%" }}
                id="codigoArticulo"
                label="Código de Artículo"
                size="small"
                inputProps={{
                  autoComplete: "off",
                }}
                name="codigoArticulo"
                value={ajusteArticuloItemLocal.codigoArticulo ?? ""}
                variant="outlined"
                onChange={handleChange}
                autoFocus
                disabled={codigoArticuloDisabled || actionCrud === "update" || actionCrud === "view" || actionCrud === "delete"}
              />
            </Grid>

            {actionCrud === "new" && (
              <Grid item xs={8}>
                <Tooltip title="buscar">
                  <Fab
                    sx={{ ml: 1, mr: 1 }}
                    color="primary"
                    aria-label="add"
                    size="small"
                    onClick={() => loadArticulo(ajusteArticuloItemLocal.codigoArticulo)}
                    disabled={codigoArticuloDisabled || actionCrud === "view" || actionCrud === "delete"}
                  >
                    <SearchIcon />
                  </Fab>
                </Tooltip>

                <Tooltip title="limpiar">
                  <Fab
                    sx={{ ml: 1, mr: 1 }}
                    color="outlined"
                    aria-label="add"
                    size="small"
                    onClick={cleanArticulo}
                    disabled={actionCrud === "view" || actionCrud === "delete"}
                  >
                    <CleaningServicesIcon />
                  </Fab>
                </Tooltip>
              </Grid>
            )}

            {tipoArticulo === "" && (
              <Grid item xs={12} sx={{ mr: 1, mb: 1 }}>
                <Card>
                  <CardContent>
                    <Typography variant="body2" color="text.secondary">
                      ...
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            )}

            {tipoArticulo === "accesorio" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosAccesorio articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "armazon" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosArmazon articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "anteojo-sol" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosAnteojoSol articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "fornitura" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosFornitura articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "lente-contacto" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosLenteContacto articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "solucion-limpieza" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosSolucionLimpieza articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            <Grid container spacing={1} sx={{ mt: 2, mb: 2 }}>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <Autocomplete
                  size="small"
                  value={valueACTiposAjusteStock}
                  onChange={(event, newValue) => {
                    setValueACTiposAjusteStock(newValue);
                  }}
                  inputValue={inputValueACTiposAjusteStock}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACTiposAjusteStock(newInputValue);
                  }}
                  id="tipoAjusteStock"
                  options={tiposAjusteStock}
                  renderInput={(params) => (
                    <TextField {...params} label="Tipo de Ajuste de Stock" />
                  )}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  getOptionLabel={(option) => option?.label || ""}
                  disabled={actionCrud === "view" || actionCrud === "delete"}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    style: { textAlign: "center" },
                  }}
                  id="cantidad"
                  label="Cantidad"
                  variant="outlined"
                  size="small"
                  name="cantidad"
                  onChange={handleChange}
                  value={ajusteArticuloItemLocal.cantidad}
                  disabled={actionCrud === "view" || actionCrud === "delete"}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={5} lg={5}>
                <TextField
                  sx={{ width: "100%" }}
                  id="descripcionAjusteArticulo"
                  inputProps={{
                    autoComplete: "off"
                  }}
                  label="Descripcion"
                  variant="outlined"
                  size="small"
                  name="descripcionAjusteArticulo"
                  value={(ajusteArticuloItemLocal.descripcionAjusteArticulo ?? "").toUpperCase()}
                  onChange={handleChange}
                  disabled={actionCrud === "view" || actionCrud === "delete"}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
            >
              {actionCrud !== "view" && (
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  startIcon={actionCrud === "delete" ? <RemoveCircleOutlineIcon /> : <SaveIcon />}
                  color={actionCrud === "delete" ? "error" : "primary"}
                >
                  {actionCrud === "delete" ? "Eliminar" : "Guardar"}
                </Button>
              )}

              <Button
                variant="outlined"
                size="small"
                onClick={handleCloseDialog}
              >
                {actionCrud === "view" ? "Cerrar" : "Cancelar"}
              </Button>
            </Box>
          </Grid>

        </DialogContent >
      </Dialog >

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default AjusteArticuloDialog;